export const DefaultMessagesNotification = {
    ErrorTitle: "Ocorreu um erro.",
    ErrorBodyGeneric: "Favor tentar novamente ou entre em contato com seu gestor.",
    ErrorBodyGetData: "Não foi possível obter os dados necessários."
}